// extracted by mini-css-extract-plugin
module.exports = {"NotFoundImage":"NotFoundPage_NotFoundImage__1OYc9"};